import React from 'react';
import PropTypes from 'prop-types';
import ArrowRight from '@deliveroo/icon-set/react/ArrowRight';
import BackgroundImage from '@deliveroo/consumer-component-library/components/BackgroundImage';
import P from '@deliveroo/consumer-component-library/components/P';
import Span from '@deliveroo/consumer-component-library/components/Span';
import Heading from '@deliveroo/consumer-component-library/components/Heading';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import CCLRichText from '@deliveroo/consumer-component-library/components/RichText';

import styles from './styles.scss';

/**
 * A component to display a single cuisine card.
 */
class RichTextCard extends React.Component {
  validateProps({ url, imageUrl, title, html, linkText }) {
    return (
      typeof url === 'string' &&
      typeof imageUrl === 'string' &&
      typeof title === 'string' &&
      typeof html === 'string' &&
      typeof linkText === 'string'
    );
  }

  componentDidMount() {
    const { url, imageUrl, title, html, linkText } = this.props;

    if (!this.validateProps({ url, imageUrl, title, html, linkText })) {
      throw new Error(`Incorrect prop-types for Storyblok RichTextCard component`);
    }
  }

  render() {
    const { url, imageUrl, title, html, linkText } = this.props;
    return (
      <div className={styles.card}>
        <a href={url} className={styles.cardLink}>
          <span className={styles.image}>
            <BackgroundImage src={imageUrl} />
          </span>

          <div className={styles.details}>
            <Heading level={3} size="x-small">
              {title}
            </Heading>
            <span className={styles.description}>
              <Span color="grey" spacing="small 0 0 0" isBlock>
                <CCLRichText>
                  {/* this output is already sanitised by Storybook's markdown-html plugin */}
                  {/* eslint-disable-next-line react/no-danger */}
                  <div dangerouslySetInnerHTML={{ __html: html }} />
                </CCLRichText>
              </Span>
            </span>
            <P adjacentVerticalSpacing="medium">
              <span className={styles.linkText}>
                {linkText}
                <Icon component={ArrowRight} size={18} spacing="0 0 0 x-small" />
              </span>
            </P>
          </div>
        </a>
      </div>
    );
  }
}

RichTextCard.propTypes = {
  /**
   * URL for the cuisine page, which the card links to.
   */
  url: PropTypes.string.isRequired,
  /**
   * URL for the image to be displayed on the card.
   */
  imageUrl: PropTypes.string.isRequired,
  /**
   * Title of the cuisine.
   */
  title: PropTypes.string.isRequired,
  /**
   * Description of the cuisine.
   */
  html: PropTypes.string.isRequired,
  /**
   * Text for the link to the cuisine page.
   */
  linkText: PropTypes.string.isRequired,
};

export default RichTextCard;
